import { instructionStrings } from '@data/instruction';
import { requiredStringField } from '@utils/forms';
import * as t from 'io-ts';
import { last } from 'lodash-es';
import * as h from 'tyrann-io';

export const instructionType = t.union([
  t.literal('customsInstruction'),
  t.literal('deliveryInstruction'),
]);

export type InstructionType = t.TypeOf<typeof instructionType>;

export const instructionStatusName = t.union([
  t.literal('送信済'),
  t.literal('未送信'),
  t.literal('修正依頼済'),
  t.literal('確認済み'),
]);

export type InstructionStatusName = t.TypeOf<typeof instructionStatusName>;

export const instructionStatus = t.type({
  name: instructionStatusName,
  time: t.string,
  message: h.omittable(t.string),
  is_visible: t.boolean,
});

export type InstructionStatus = t.TypeOf<typeof instructionStatus>;

export const getLastVisibleStatus = (
  status: InstructionStatus[],
): InstructionStatus | undefined => {
  return last(status.filter((s) => s.is_visible));
};

export const instructionOverview = t.type({
  delivery_has_unsent: t.boolean,
  customs_has_unsent: t.boolean,
});

export const changeRequiredForm = t.type({
  message: requiredStringField(instructionStrings.requestChangesReason),
});

export type ChangeRequiredForm = t.TypeOf<typeof changeRequiredForm>;

export const changeRequiredFormInitialValues: ChangeRequiredForm = {
  message: '',
};
